import { render, staticRenderFns } from "./DetailShensha.vue?vue&type=template&id=54f88595&"
import script from "./DetailShensha.vue?vue&type=script&lang=js&"
export * from "./DetailShensha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports